export default __webpack_public_path__ + "static/media/city_hall.7d572a50.svg";